export default validationSchema => {
    return (values) => {
        let errors = {};
        const doesMatchState = (conditionKey, conditionValue) => {
            return values[conditionKey] === conditionValue;
        };

        //Loop through fields in schema
        Object.keys(validationSchema).map(fieldName => {
            let applicable = true; //By default, we assume validation is applicable

            //1. Check if stateConditions exist before proceeding with the current validation
            if ('stateConditions' in validationSchema[fieldName]) {
                applicable = false; //Since conditions are present, let's ensure they are all met
                let conditions = validationSchema[fieldName]['stateConditions'];

                //Loop through each stateCondition
                Object.keys(conditions).map(condKey => {
                    if (Array.isArray(conditions[condKey])) {
                        //If any of the contents of the array are true, this particular condition is met
                        for (var val of conditions[condKey]) {
                            if (doesMatchState(condKey, val) === true) {
                                applicable = true;
                                break;
                            }
                        }
                    } else {
                        //If condition is met, applicable will be set to true
                        //Override applicable value so that we don't need url on the card in order to save "Link" with "Is Ad?" enabled
                        if(values['isAd'] && condKey === 'type' && conditions[condKey] === 'link' ){
                            applicable = false;
                        } else{
                            applicable = doesMatchState(condKey, conditions[condKey]);
                        }
                    }
                    return true;
                });
            }
            //If state conditions are not met, we don't want to perform further validation checks
            if (!applicable) return false;

            //If required is true, let's check for a value, set appropriate errors and return
            if ('required' in validationSchema[fieldName]) {
                if (!values[fieldName]) {
                    errors[fieldName] = validationSchema[fieldName].error || `${fieldName} is required`;
                    return true;
                }
            }
            //If a value exists (something has been entered on the form, let's validate against any validators we have for that field)
            if (values[fieldName] && 'validator' in validationSchema[fieldName]) {
                //Retrieve relevant regEx
                //Test value against regEx
                let validator = validationSchema[fieldName].validator;
                if (validator.regEx.test(values[fieldName]) === false) {
                    errors[fieldName] = validationSchema[fieldName].error || `Invalid ${fieldName} entered`;
                } else {
                    delete errors[fieldName];
                }
            } else {
                delete errors[fieldName];
            }

            return true;
        });

        return errors;
    };
};
